import {
    selectRole,
    updateContactDetails,
    updateContactEmergencyDetails
} from "./actions";

import ItemView from "../../components/ItemView/ItemView.vue"

export default [{
    "path": "/",
    "component": { ...ItemView },
    "name": "Personal and Contact Details",
    "meta": {
        "app": "ftc",
        "name": "Personal and Contact Details",
        title() {
            return `Your Contact Details`;
        },
        "sideNav": true,
        "sideNavSection": "Your Details",
        "hideBackButton": true,
        "menuActions": [{
            "label": "Select Role",
            "action": selectRole
        }, {
            "label": "Update Contact Details",
            "action": updateContactDetails
        }, {
            "label": "Update Emergency Contact Details",
            "action": updateContactEmergencyDetails
        }],
        "dataFields": [{
            "label": "Full Name",
            compute({ item }) {
                return `${item.raw.User.FirstName} ${item.raw.User.LastName}`
            }
        }, {
            "label": "Email",
            "key": "Email"
        }, {
            "label": "Phone Number",
            "key": "raw.User.Phone"
        }, {
            "label": "Bate of Birth",
            "key": "DOB",
            "type": "date"
        }, {
            "label": "Role",
            "key": "Role"
        }, {
            "label": "Emergency Contact Details",
            "break": true,
            "class": "md:col-span-3",
        }, {
            "label": "Name",
            "key": "EmergencyContact.Name",
            compute({ item }) {
                return `${item?.EmergencyContact?.FirstName} ${item?.EmergencyContact?.LastName}`
            }
        }, {
            "label": "Phone",
            "key": "EmergencyContact.Phone"
        }, {
            "label": "Phone 2",
            "key": "EmergencyContact.Phone2"
        }, {
            "label": "Relationship",
            "key": "EmergencyContact.Relation"
        }]
    }
}];
